import React, { Component } from 'react';
import ChatPng from '../Images/Chat.png';
import '../css/Global.css';


class Chat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Conectado: false,
            Guid: this.props.getGuid(),
            Mensaje: "",
            Mensajes: [],
            ws: null,
            Disponible: false,
            Cerrar: false,
            Estado: 1,
            Mensaje1: "Necesitas ayuda",
            Mensaje2: "Da clic para iniciar chat",
            Nombre: "",
            Tel: "",
            Email: "",
            Alerta: "",
            Establecido: false,
            NoIniciar: false
        }
        this.cerrar = this.cerrar.bind(this);
        this.conectar = this.conectar.bind(this);
        this.cambiarGuid = this.cambiarGuid.bind(this);
        this.cambiarMensaje = this.cambiarMensaje.bind(this);
        this.iniciar = this.iniciar.bind(this);
        this.enviar = this.enviar.bind(this);
        this.unLoad = this.unLoad.bind(this);
        this.handleNombre = this.handleNombre.bind(this);
        this.handleTel = this.handleTel.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.validar = this.validar.bind(this);
        this.cambiarEstado2 = this.cambiarEstado2.bind(this);
        this.revisarDisponibilidad = this.revisarDisponibilidad.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);

        if (!this.state.Conectado) {
            this.conectar();
        };
        if (!this.state.Establecido) {
            this.state.Establecido = true;
            window.addEventListener("beforeunload", this.unLoad);
        }
    }

    validar() {
        if (this.state.Nombre == "") {
            this.setState({ Alerta: "Por favor proporcione su nombre" })
            return;
        };
        //if (this.state.Email == "" && this.state.Tel == "") {
        //    this.setState({ Alerta: "Por favor proporcione un correo o un tel." })
        //    return;
        //}
        if (this.state.Conectado === false) {
            this.conectar(null, () => {
                this.iniciar();
                var msj = [];
                var m = { SenderName: "ICYTEG", Message: "Gracias por considerar nuestros programas educativos, en ¿qué le podemos servir el día de hoy?" };
                msj.push(m);
                this.setState({ Alerta: "", Estado: 3, Mensajes: msj, NoIniciar: false })
            });
        } else {
            this.iniciar();
            var msj = [];
            var m = { SenderName: "ICYTEG", Message: "Gracias por considerar nuestros programas educativos, en ¿qué le podemos servir el día de hoy?" };
            msj.push(m);
            this.setState({ Alerta: "", Estado: 3, Mensajes: msj, NoIniciar: false })
        }

       
    }


    handleNombre(event) {
        this.setState({ Nombre: event.target.value });
    }

    handleTel(event) {
        this.setState({ Tel: event.target.value });

    }

    handleEmail(event) {
        this.setState({ Email: event.target.value });

    }

    revisarDisponibilidad() {
        //if (this.state.Disponible == false) {
            var xhr = new XMLHttpRequest();
            var principal = this;

            xhr.open("GET", "chat/Servicio/Estado", true);

            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onload = function () {
                if (xhr.status === 200) {
                    try {
                        switch (xhr.responseText) {
                            case "false":
                                principal.setState({ Disponible: false });
                                break;
                            case "true":
                                principal.setState({ Disponible: true });

                                break;
                        }
                    } catch (err) {

                    };
                };

            };

            xhr.send();
        //}
    }

    cambiarEstado2() {
        this.setState({ Estado: 2 });
        
    }

    unLoad() {
        try {
            this.state.Cerrar = true;
            this.state.ws.close();

        } catch (err) {
            console.write(err);
        }
    }

    componentDidMount() {
        setInterval(this.revisarDisponibilidad, 2000);
    }

    componentWillUnmount() {
        try {
            window.removeEventListener("beforeunload", this.unLoad);
        } catch (err) {

        }
    }

    cambiarGuid(event) {
        this.setState({ Guid: event.target.value });
    }

    cambiarMensaje(event) {
        this.setState({ Mensaje: event.target.value });
    }


    conectar(event, fn) {
        //var webs = new WebSocket('wss://localhost:44314/chat/Servicio');
        //var webs = new WebSocket('wss://192.168.0.201:9091/chat/Servicio');
        //var webs = new WebSocket('wss://DJLC-M7720:9091/chat/Servicio');
        var webs = new WebSocket('wss://www.icyteg.edu.mx/chat/Servicio');
        //var webs = new WebSocket('ws://www.icyteg.edu.mx:90/chat/Servicio');
        webs.onopen = () => {
            //this.iniciar();
            webs.send(this.state.Guid);
            this.setState({ Conectado: true });
            if (fn != undefined && fn != null) {
                fn();
            }
        }

        this.state.ws = webs;
        var principal = this;
        webs.onclose = (event) => {
            //console.write(event.reason);
            principal.setState({ Conectado: false });
            if (principal.state.Cerrar === false) {
                setTimeout(() => { if (this.state.NoIniciar === false) { principal.conectar(); }; }, 1000);
            };
        }

        webs.onmessage = (event) => {
            var msj = this.state.Mensajes;
            var N = JSON.parse(event.data);
            if (N.Action == 0) {
                switch (N.Value) {
                    case "true":
                        this.setState({ Disponible: true });
                        break;
                    case "false":
                        this.setState({ Disponible: false });
                        break;
                }
            } else {
                if (this.state.Estado == 3) {
                    msj.push(JSON.parse(N.Value));
                    this.scrollToBottom();
                }
                this.setState({ Mensajes: msj, Mensaje1: JSON.parse(N.Value).Message });
            }
        }

    }

    iniciar() {
        
        this.state.ws.send(this.state.Nombre);
        this.state.ws.send(this.state.Tel);
        this.state.ws.send(this.state.Email);
        
    }



    enviar(event) {

        var msj = this.state.Mensajes;
        if (msj === "") {
            return;
        };

        var m = { toGuid: "0", FromGuid: this.state.Guid, Message: this.state.Mensaje, Tiempo: Date.now(), SenderName: this.state.Nombre };
        msj.push(m);
        this.state.ws.send(this.state.Mensaje);
        this.setState({ Mensaje: "", Mensajes: msj });
        this.scrollToBottom();
        
    }

    scrollToBottom() {
        setTimeout(() => {
            try {
                var objDiv = document.getElementById("ChatMensajes");
                objDiv.scrollTop = objDiv.scrollHeight;
            } catch (err) {

            };

        }, 900);
    }

    cerrar() {
        this.state.ws.close();
        this.setState({ Estado: 1, Mensaje1: "Necesitas ayuda", NoIniciar: true });
    }

    render() {
        if (this.state.Disponible) {
            return (
                <div style={{ height: "auto", width: "auto", position: "fixed", bottom: "80px", right: "90px", left: "auto", top: "auto" }}>
                    {this.state.Estado === 1 ?
                        <div className="ChatMini" onClick={this.cambiarEstado2}>
                            <img src={ChatPng} alt="Chat en vivo" onClick={this.cambiarEstado2} /> <span onClick={this.cambiarEstado2}>{this.state.Mensaje1}</span>
                        </div>
                        : null
                    }

                    {this.state.Estado === 2 ?
                        <div className="ChatMini" >
                            <table>
                                <tbody>

                                    
                                    <tr style={{ height: "15px" }}>
                                        <td colSpan="2" >
                                            <div style={{ width: "350px", margin: "10px", textAlign: "center", fontSize: "12pt" }}>
                                                Si deseas que te enviémos una copia de la conversación, proporciona un teléfono o correo electrónico (OPCIONAL). 
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style={{ height: "25px" }}>
                                        <td> Nombre: </td>
                                        <td> <input value={this.state.Nombre} onChange={this.handleNombre} /></td>
                                    </tr>
                                    <tr style={{ height: "25px" }}>
                                        <td> Tel: </td>
                                        <td> <input value={this.state.Tel} onChange={this.handleTel} /></td>
                                    </tr>
                                    <tr style={{ height: "25px" }}>
                                        <td> Correo electr&oacute;nico: </td>
                                        <td> <input value={this.state.Email} onChange={this.handleEmail} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2"> <div style={{ color: "red" }}>{this.state.Alerta}</div> </td>
                                    </tr>
                                    <tr style={{ height: "25px" }}>
                                        <td colSpan="2">
                                            <input type="button" value="Iniciar Chat" onClick={this.validar} />
                                            <input style={{ backgroundColor: "red", color: "white" }} type="button" value="Cerrar" onClick={this.cerrar} />

                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        : null
                    }

                    {this.state.Estado === 3 ?
                        <div className="ChatMini">
                            <div style={{ width: "280px", height: "380px", overflowY: "scroll" }} id="ChatMensajes">
                                {this.state.Mensajes.map((item, index) => {
                                    return (
                                        (item.FromGuid == this.state.Guid) ?
                                            <div className="ChatMessage1">
                                                <div>{item.SenderName}</div>
                                                <div style={{border: "1px solid gray", padding:"5px"}}>{item.Message}</div>
                                            </div>
                                            :
                                            <div className="ChatMessage2">
                                                <div>{item.SenderName}</div>
                                                <div style={{ border: "1px solid gray", padding: "5px"}}>{item.Message}</div>
                                            </div>
                                        
                                        );
                                })}

                            </div>
                            <div>
                                <table>
                                    <tbody>
                                        <tr >
                                            <td style={{ width: "70%" }}>
                                                <textarea rows="3"  value={this.state.Mensaje} onChange={this.cambiarMensaje} />
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <div>
                                                    <input type="button" value="Enviar" onClick={this.enviar} />
                                                </div>
                                                <div>
                                                    <input style={{ backgroundColor: "red", color: "white" }} type="button" value="Cerrar" onClick={this.cerrar} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : null
                    }
                    {this.state.Estado === 4 ?
                        <div style={{ padding: "180px" }}>
                            {this.state.Conectado ?
                                <div>Conectado</div>
                                :
                                <div>Desconectado</div>}
                            {this.state.Disponible ?
                                <div>Disponible</div>
                                :
                                <div>No Disponible</div>}
                            <input value={this.state.Guid} onChange={this.cambiarGuid} />
                            <input type="button" value="Conectar" onClick={this.conectar} />

                            {this.state.Conectado ?
                                <div>
                                    <input value={this.state.Mensaje} onChange={this.cambiarMensaje} />
                                    <input type="button" value="Enviar Mensaje" onClick={this.enviar} />
                                </div>
                                :
                                <div></div>
                            }
                            {
                                this.state.Mensajes.map((item, index) => {
                                    return (
                                        <div>
                                            {item.Value}
                                        </div>
                                    )
                                }

                                )
                            }
                        </div>
                        : null
                    }

                </div>
            )
        } else {
            return (<div></div>);
        };
       
    }
}


export default Chat;


// WEBPACK FOOTER //
// ./src/components/Chat.js